import React from "react";
import styled from "styled-components";
import FormattedDate from "../FormattedDate";

const ArticleDate = ({ children }) => {
  return (
    <StyledArticleDate>
      <FormattedDate 
        date={children} 
        format={{
          year: "numeric",
          month: "long",
          day: "numeric",
          timeZone: "America/New_York"
        }} 
      />
    </StyledArticleDate>
  );
};

export default ArticleDate;

const StyledArticleDate = styled.div`
  margin: 0;
  display: block;
  text-align: center;
`;